// ============================================================
// textStyles.js — shared text-overlay style definitions
// ------------------------------------------------------------
// Used by both the live preview (EditorCanvas, CSS) and the flattened
// export (canvasExport, ctx.fillText) so on-screen == saved output.
//
//   bg: 'none'   — no background
//       'pill'   — dark translucent rounded box (Editor style)
//       'bubble' — opaque coloured rounded box (Bubble style)
// Sizes are stored as a fraction of image height (`sizeFrac`) so they stay
// resolution-independent between preview and export.
// ============================================================

export const TEXT_STYLES = {
  classic:   { label: 'Classic',   fontFamily: "'Helvetica Neue', Arial, sans-serif", weight: 700, italic: false, uppercase: false, bg: 'none',   shadow: true },
  signature: { label: 'Signature', fontFamily: "'Snell Roundhand', 'Brush Script MT', cursive", weight: 600, italic: true, uppercase: false, bg: 'none', shadow: true },
  editor:    { label: 'Editor',    fontFamily: "'Helvetica Neue', Arial, sans-serif", weight: 600, italic: false, uppercase: false, bg: 'pill',   shadow: false },
  poster:    { label: 'Poster',    fontFamily: "'Arial Black', Impact, sans-serif",   weight: 900, italic: false, uppercase: true,  bg: 'none',   shadow: true },
  bubble:    { label: 'Bubble',    fontFamily: "'Helvetica Neue', Arial, sans-serif", weight: 700, italic: false, uppercase: false, bg: 'bubble', shadow: false },
  neon:      { label: 'Neon',      fontFamily: "'Helvetica Neue', Arial, sans-serif", weight: 800, italic: false, uppercase: false, bg: 'none',   shadow: false, glow: true, defaultColor: '#5ffbf1' },
  shadow:    { label: 'Shadow',    fontFamily: "'Helvetica Neue', Arial, sans-serif", weight: 700, italic: false, uppercase: false, bg: 'none',   shadow: false, dropShadow: true },
  outline:   { label: 'Outline',   fontFamily: "'Arial Black', Impact, sans-serif",   weight: 900, italic: false, uppercase: true,  bg: 'none',   shadow: false, outline: true },
};

export const TEXT_STYLE_LIST = Object.entries(TEXT_STYLES).map(([id, v]) => ({ id, ...v }));

export const MAX_TEXT_LAYERS = 10;

// A fresh text layer centered on the image.
export function newTextLayer() {
  return {
    id: crypto.randomUUID(),
    text: 'Your text',
    style: 'classic',
    color: '#ffffff',
    align: 'center',     // 'left' | 'center' | 'right'
    sizeFrac: 0.09,      // font height as fraction of image height
    opacity: 55,         // background opacity (Editor/Bubble), 0..100
    x: 0.5,              // normalized center
    y: 0.5,
  };
}

// Resolve the foreground text colour for a style + layer.
export function textFillColor(style, layer) {
  return style.bg === 'bubble' ? '#ffffff' : (layer.color || '#ffffff');
}
